import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { sanitizeHttpUrl } from '@/client/utils/string'

interface Props {
  name: string
  url: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmCardButton',
  props: {
    name: null,
    url: null
  },
  setup(__props: any) {

const props = __props as {
  name: string
  url: string
};



const safeUrl = computed(() => sanitizeHttpUrl(props.url))

return { __sfc: true,props, safeUrl }
}

})